import React, { useState, useEffect } from "react"
import { Container, Row, Col, Card, CardBody, Table } from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { URLS } from "../../Url"
import axios from "axios"

const Dashboard = () => {
  const [form, setform] = useState([])
  const [Users, setUsers] = useState([])
  const [Vendors, setVendors] = useState([])

  var gets = localStorage.getItem("authUser")
  var data = JSON.parse(gets)
  var datas = data.token

  useEffect(() => {
    GetSettings()
  }, [])

  const GetSettings = () => {
    var token = datas

    axios
      .post(
        URLS.GetDashboard,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(res => {
        setform(res.data)
        setUsers(res.data.latestUsers)
        setVendors(res.data.latestVendors)
      })
  }

  const popularpost = [
    {
      id: 1,
      title: "Mobile Recharge",
      like: form?.mobileRechargesCountdocuments,
      comment: form?.mobileRechargesAmount,
    },
    {
      id: 2,
      title: "Fastag",
      like: form?.FASTagRechargesCountdocuments,
      comment: form?.FASTagrechargesAmount,
    },
    {
      id: 3,
      title: "Electricity",
      like: form?.ElectricityRechargesCountdocuments,
      comment: form?.ElectricityrechargesAmount,
    },
    {
      id: 4,
      title: "DTH",
      like: form?.DTHRechargesCountdocuments,
      comment: form?.DTHrechargesAmount,
    },
    {
      id: 4,
      title: "Water Bill",
      like: form?.WaterresultRechargesCountdocuments,
      comment: form?.WaterresultRechargesAmount,
    },
    {
      id: 5,
      title: "Total / Count / Amount",
      like: form?.Servicescounts,
      comment: form?.ServicecountAmounts,
    },
  ]

  const popularpost1 = [
    {
      id: 1,
      title: "Total Poster's Designs",
      like: form?.savetemplatescountDocuments,
    },
    {
      id: 2,
      title: "Total Images Upload",
      like: form?.imagesCount,
    },
    {
      id: 3,
      title: "Total Videos Upload",
      like: form?.videoCount,
    },
    {
      id: 4,
      title: "Total Post's Upload",
      like: form?.overalluserpostscountDocuments,
    },
  ]

  var gets = localStorage.getItem("authUser")
  var data = JSON.parse(gets)
  var Roles = data?.rolesAndPermission[0]

  return (
    <React.Fragment>
      {Roles?.Dashview === true || Roles?.accessAll === true ? (
        <>
          <div className="page-content">
            <Container fluid>
              <Breadcrumbs
                title={"Home"}
                breadcrumbItem={"Dashboard"}
              />
              <Row>
                <h5 className="text-primary pb-2">Business Man / Users </h5>
              </Row>
              <Row>
                <Col md="3">
                  <Card
                    className="mini-stats-wid"
                    style={{ background: "#7367F0" }}
                  >
                    <CardBody>
                      <div className="d-flex mt-2 mb-2">
                        <div className="flex-grow-1">
                          <p
                            className="fw-small"
                            style={{ color: "white", fontSize: "9px" }}
                          >
                            Total Users
                          </p>
                          <h4 className="mb-0" style={{ color: "white" }}>
                            {form.totalUsers}
                          </h4>
                        </div>
                        <div className="avatar-sm rounded-circle bg-white align-self-center mini-stat-icon">
                          <span className="avatar-title rounded-circle  bg-white ">
                            <i
                              className="bx bx-group"
                              style={{ color: "#7367F0", fontSize: "24px" }}
                            ></i>
                          </span>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
                <Col md="3">
                  <Card
                    className="mini-stats-wid"
                    style={{ background: "rgb(0,188,212)" }}
                  >
                    <CardBody>
                      <div className="d-flex mt-2 mb-2">
                        <div className="flex-grow-1">
                          <p
                            className="fw-small"
                            style={{ color: "white", fontSize: "9px" }}
                          >
                            Total Active Users
                          </p>
                          <h4 className="mb-0" style={{ color: "white" }}>
                            {form.totalVerifiedUsers}
                          </h4>
                        </div>
                        <div className="avatar-sm rounded-circle bg-white align-self-center mini-stat-icon">
                          <span className="avatar-title rounded-circle  bg-white ">
                            <i
                              className="bx bx-group"
                              style={{
                                color: "rgb(0,188,212)",
                                fontSize: "24px",
                              }}
                            ></i>
                          </span>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
                <Col md="3">
                  <Card
                    className="mini-stats-wid"
                    style={{ background: "#FF9800" }}
                  >
                    <CardBody>
                      <div className="d-flex mt-2 mb-2">
                        <div className="flex-grow-1">
                          <p
                            className="fw-small"
                            style={{ color: "white", fontSize: "9px" }}
                          >
                            Total Business Man
                          </p>
                          <h4 className="mb-0" style={{ color: "white" }}>
                            {form.totalVendors}
                          </h4>
                        </div>
                        <div className="avatar-sm rounded-circle bg-white align-self-center mini-stat-icon">
                          <span className="avatar-title rounded-circle  bg-white ">
                            <i
                              className="bx bx-group"
                              style={{ color: "#FF9800", fontSize: "24px" }}
                            ></i>
                          </span>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
                <Col md="3">
                  <Card
                    className="mini-stats-wid"
                    style={{ background: "#E91E63" }}
                  >
                    <CardBody>
                      <div className="d-flex mt-2 mb-2">
                        <div className="flex-grow-1">
                          <p
                            className="fw-small"
                            style={{ color: "white", fontSize: "9px" }}
                          >
                            Total Verified Business Man
                          </p>
                          <h4 className="mb-0" style={{ color: "white" }}>
                            {form.totalVerifiedVendors}
                          </h4>
                        </div>
                        <div className="avatar-sm rounded-circle bg-white align-self-center mini-stat-icon">
                          <span className="avatar-title rounded-circle  bg-white ">
                            <i
                              className="bx bx-group"
                              style={{ color: "#E91E63", fontSize: "24px" }}
                            ></i>
                          </span>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
              <Row>
                <h5 className="text-primary pb-2">Listings </h5>
              </Row>
              <Row>
                <Col md="3">
                  <Card
                    className="mini-stats-wid"
                    style={{ background: "#2F8ADC" }}
                  >
                    <CardBody>
                      <div className="d-flex mt-2 mb-2">
                        <div className="flex-grow-1">
                          <p
                            className="fw-small"
                            style={{ color: "white", fontSize: "9px" }}
                          >
                            Total Business Man Listings
                          </p>
                          <h4 className="mb-0" style={{ color: "white" }}>
                            {form.totalVendorListingsCount}
                          </h4>
                        </div>
                        <div className="avatar-sm rounded-circle bg-white align-self-center mini-stat-icon">
                          <span className="avatar-title rounded-circle  bg-white ">
                            <i
                              className="bx bx-list-ol"
                              style={{ color: "#2F8ADC", fontSize: "24px" }}
                            ></i>
                          </span>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
                <Col md="3">
                  <Card
                    className="mini-stats-wid"
                    style={{ background: "#2D50FF" }}
                  >
                    <CardBody>
                      <div className="d-flex mt-2 mb-2">
                        <div className="flex-grow-1">
                          <p
                            className="fw-small"
                            style={{ color: "white", fontSize: "9px" }}
                          >
                            Total Business Man Rejected Listings
                          </p>
                          <h4 className="mb-0" style={{ color: "white" }}>
                            {form.totalRejectedVendorListingsCount}
                          </h4>
                        </div>
                        <div className="avatar-sm rounded-circle bg-white align-self-center mini-stat-icon">
                          <span className="avatar-title rounded-circle  bg-white ">
                            <i
                              className="bx bx-list-ol"
                              style={{
                                color: "#2D50FF",
                                fontSize: "24px",
                              }}
                            ></i>
                          </span>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
                <Col md="3">
                  <Card
                    className="mini-stats-wid"
                    style={{ background: "#8458E8" }}
                  >
                    <CardBody>
                      <div className="d-flex mt-2 mb-2">
                        <div className="flex-grow-1">
                          <p
                            className="fw-small"
                            style={{ color: "white", fontSize: "9px" }}
                          >
                            Total Users Listings
                          </p>
                          <h4 className="mb-0" style={{ color: "white" }}>
                            {form.totalUserListingsCount}
                          </h4>
                        </div>
                        <div className="avatar-sm rounded-circle bg-white align-self-center mini-stat-icon">
                          <span className="avatar-title rounded-circle  bg-white ">
                            <i
                              className="bx bx-list-ol"
                              style={{ color: "#8458E8", fontSize: "24px" }}
                            ></i>
                          </span>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
                <Col md="3">
                  <Card
                    className="mini-stats-wid"
                    style={{ background: "#E35451" }}
                  >
                    <CardBody>
                      <div className="d-flex mt-2 mb-2">
                        <div className="flex-grow-1">
                          <p
                            className="fw-small"
                            style={{ color: "white", fontSize: "9px" }}
                          >
                            Total Users Rejected Listings
                          </p>
                          <h4 className="mb-0" style={{ color: "white" }}>
                            {form.totalRejectedUserListingsCount}
                          </h4>
                        </div>
                        <div className="avatar-sm rounded-circle bg-white align-self-center mini-stat-icon">
                          <span className="avatar-title rounded-circle  bg-white ">
                            <i
                              className="bx bx-list-ol"
                              style={{ color: "#E35451", fontSize: "24px" }}
                            ></i>
                          </span>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
              <Row>
                <h5 className="text-primary pb-2">Support </h5>
              </Row>
              <Row>
                <Col md="3">
                  <Card
                    className="mini-stats-wid"
                    style={{ background: "#3B3D3E" }}
                  >
                    <CardBody>
                      <div className="d-flex mt-2 mb-2">
                        <div className="flex-grow-1">
                          <p
                            className="fw-small"
                            style={{ color: "white", fontSize: "9px" }}
                          >
                            Total Tickets
                          </p>
                          <h4 className="mb-0" style={{ color: "white" }}>
                            {form.totalTickets}
                          </h4>
                        </div>
                        <div className="avatar-sm rounded-circle bg-white align-self-center mini-stat-icon">
                          <span className="avatar-title rounded-circle  bg-white ">
                            <i
                              className="bx bx-support"
                              style={{ color: "#3B3D3E", fontSize: "24px" }}
                            ></i>
                          </span>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
                <Col md="3">
                  <Card
                    className="mini-stats-wid"
                    style={{ background: "#361459" }}
                  >
                    <CardBody>
                      <div className="d-flex mt-2 mb-2">
                        <div className="flex-grow-1">
                          <p
                            className="fw-small"
                            style={{ color: "white", fontSize: "9px" }}
                          >
                            Total Pending Tickets
                          </p>
                          <h4 className="mb-0" style={{ color: "white" }}>
                            {form.totalPendingTickets}
                          </h4>
                        </div>
                        <div className="avatar-sm rounded-circle bg-white align-self-center mini-stat-icon">
                          <span className="avatar-title rounded-circle  bg-white ">
                            <i
                              className="bx bx-support"
                              style={{
                                color: "#361459",
                                fontSize: "24px",
                              }}
                            ></i>
                          </span>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
                <Col md="3">
                  <Card
                    className="mini-stats-wid"
                    style={{ background: "#7D2929" }}
                  >
                    <CardBody>
                      <div className="d-flex mt-2 mb-2">
                        <div className="flex-grow-1">
                          <p
                            className="fw-small"
                            style={{ color: "white", fontSize: "9px" }}
                          >
                            Total Rejected Tickets
                          </p>
                          <h4 className="mb-0" style={{ color: "white" }}>
                            {form.totalRejectedTickets}
                          </h4>
                        </div>
                        <div className="avatar-sm rounded-circle bg-white align-self-center mini-stat-icon">
                          <span className="avatar-title rounded-circle  bg-white ">
                            <i
                              className="bx bx-support"
                              style={{ color: "#7D2929", fontSize: "24px" }}
                            ></i>
                          </span>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
                <Col md="3">
                  <Card
                    className="mini-stats-wid"
                    style={{ background: "#032889" }}
                  >
                    <CardBody>
                      <div className="d-flex mt-2 mb-2">
                        <div className="flex-grow-1">
                          <p
                            className="fw-small"
                            style={{ color: "white", fontSize: "9px" }}
                          >
                            Total ReSolved Tickets
                          </p>
                          <h4 className="mb-0" style={{ color: "white" }}>
                            {form.totalSolvedTickets}
                          </h4>
                        </div>
                        <div className="avatar-sm rounded-circle bg-white align-self-center mini-stat-icon">
                          <span className="avatar-title rounded-circle  bg-white ">
                            <i
                              className="bx bx-support"
                              style={{ color: "#032889", fontSize: "24px" }}
                            ></i>
                          </span>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
              <Row>
                <Col lg="6">
                  <div>
                    <h5 className="mt-3 text-primary pb-2">
                      Latest Business Man
                    </h5>
                    <Card>
                      <CardBody>
                        <div className="table-rep-plugin mt-4">
                          <Table hover bordered responsive>
                            <thead>
                              <tr className="text-center">
                                <th>SlNo</th>
                                <th>Name</th>
                                <th>Phone</th>
                                <th>Community</th>
                              </tr>
                            </thead>
                            <tbody>
                              {Vendors.map((data, key) => (
                                <tr key={key} className="text-center">
                                  <td>{key + 1}</td>
                                  <td>{data.name}</td>
                                  <td>{data.phone}</td>
                                  <td>{data.community}</td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        </div>
                      </CardBody>
                    </Card>
                  </div>
                </Col>
                <Col lg="6">
                  <h5 className="mt-3 text-primary pb-2">Latest Users</h5>
                  <div>
                    <Card>
                      <CardBody>
                        <div className="table-rep-plugin mt-4">
                          <Table hover bordered responsive>
                            <thead>
                              <tr className="text-center">
                                <th>SlNo</th>
                                <th>Name</th>
                                <th>Phone</th>
                                <th>Community</th>
                              </tr>
                            </thead>
                            <tbody>
                              {Users.map((data, key) => (
                                <tr key={key} className="text-center">
                                  <td>{key + 1}</td>
                                  <td>{data.name}</td>
                                  <td>{data.phone}</td>
                                  <td>{data.community}</td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        </div>
                      </CardBody>
                    </Card>
                  </div>
                </Col>
              </Row>
              <Row>
                {/* <Col md={6}>
                  <h5 className="text-primary pb-2">Services </h5>
                  <Card>
                    <CardBody>
                      <div className="table-responsive">
                        <table className="table align-middle table-nowrap mb-0">
                          <thead>
                            <tr className="text-center">
                              <th scope="col">Service Title</th>
                              <th scope="col">Service Count</th>
                              <th scope="col">Service Amount</th>
                            </tr>
                          </thead>
                          <tbody>
                            {popularpost.map((popularpost, key) => (
                              <tr key={key} className="text-center">
                                <td>
                                  <h5 className="font-size-13 text-truncate mb-1">
                                    {popularpost.title}
                                  </h5>
                                </td>
                                <td>{popularpost.like}</td>
                                <td>{popularpost.comment} /-</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </CardBody>
                  </Card>
                </Col> */}
                <Col md={12}>
                  <h5 className="text-primary pb-2 ">Posts </h5>
                  <Card>
                    <CardBody>
                      <div
                        className="table-responsive mb-5 mt-4"
                        style={{ paddingTop: "16px" }}
                      >
                        <table className="table align-middle table-nowrap mb-0 table-bordered table-hover">
                          <thead>
                            <tr className="text-center">
                              <th scope="col"> Total Post</th>
                              <th scope="col"> Count</th>
                            </tr>
                          </thead>
                          <tbody>
                            {popularpost1.map((popularpost, key) => (
                              <tr key={key} className="text-center">
                                <td>
                                  <h5 className="font-size-13 text-truncate mb-1">
                                    {popularpost.title}
                                  </h5>
                                </td>
                                <td>{popularpost.like}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>
          </div>
        </>
      ) : (
        ""
      )}
    </React.Fragment>
  )
}

export default Dashboard
